import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=47f1fc64&scoped=true&"
import script from "./Instructors.vue?vue&type=script&lang=ts&"
export * from "./Instructors.vue?vue&type=script&lang=ts&"
import style0 from "./Instructors.vue?vue&type=style&index=0&id=47f1fc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1fc64",
  null
  
)

export default component.exports